import React from 'react';

type YouTubeIconProps = React.SVGProps<SVGSVGElement> & {
  weight?: 'regular' | 'fill' | 'bold' | 'light' | 'thin' | 'duotone';
};

export const YouTubeIcon: React.FC<YouTubeIconProps> = ({ className = '', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    className={className}
    {...props}
  >
    <path
      fill="currentColor"
      d="M236.4 71.4c-2.5-9.3-9.8-16.6-19.1-19.1C200.5 48 128 48 128 48S55.5 48 38.7 52.3c-9.3 2.5-16.6 9.8-19.1 19.1C15.3 88.2 15.3 128 15.3 128s0 39.8 4.3 56.6c2.5 9.3 9.8 16.6 19.1 19.1C55.5 208 128 208 128 208s72.5 0 89.3-4.3c9.3-2.5 16.6-9.8 19.1-19.1 4.3-16.8 4.3-56.6 4.3-56.6s0-39.8-4.3-56.6Z"
    />
    <path fill="#fff" d="m104 161 60-33-60-33v66Z" />
  </svg>
);

export default YouTubeIcon;
